import { Editor } from '@tiptap/core';
import { ToolbarOptions } from './types';

export const ToolbarGroups = {
  [ToolbarOptions.TextStyle]: [
    ToolbarOptions.Bold,
    ToolbarOptions.Italic,
    ToolbarOptions.Underline,
    ToolbarOptions.Strike,
  ],
  [ToolbarOptions.List]: [ToolbarOptions.BulletList, ToolbarOptions.OrderedList],
  [ToolbarOptions.Align]: [
    ToolbarOptions.AlignLeft,
    ToolbarOptions.AlignCenter,
    ToolbarOptions.AlignRight,
    ToolbarOptions.AlignJustify,
  ],
};

export const getToolbarItems = (editor: Editor) => ({
  [ToolbarOptions.Bold]: {
    label: 'Bold',
    onClick: () => editor.chain().focus().toggleBold().run(),
    icon: 'M8 11H12.5C13.8807 11 15 9.88071 15 8.5C15 7.11929 13.8807 6 12.5 6H8V11ZM18 15.5C18 17.9853 15.9853 20 13.5 20H6V4H12.5C14.9853 4 17 6.01472 17 8.5C17 9.70431 16.5269 10.7981 15.7564 11.6058C17.0979 12.3847 18 13.837 18 15.5ZM8 13V18H13.5C14.8807 18 16 16.8807 16 15.5C16 14.1193 14.8807 13 13.5 13H8Z',
  },
  [ToolbarOptions.Italic]: {
    label: 'Italic',
    onClick: () => editor.chain().focus().toggleItalic().run(),
    icon: 'M15 20H7V18H9.92661L12.0425 6H9V4H17V6H14.0734L11.9575 18H15V20Z',
  },
  [ToolbarOptions.Underline]: {
    label: 'Underline',
    onClick: () => editor.chain().focus().toggleUnderline().run(),
    icon: 'M8 3V12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12V3H18V12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12V3H8ZM4 20H20V22H4V20Z',
  },
  [ToolbarOptions.Strike]: {
    label: 'Strike',
    onClick: () => editor.chain().focus().toggleStrike().run(),
    icon: 'M17.1538 14C17.3846 14.5161 17.5 15.0893 17.5 15.7196C17.5 17.0625 16.9762 18.1116 15.9286 18.867C14.8809 19.6223 13.4335 20 11.5862 20C9.94674 20 8.32335 19.6185 6.71592 18.8555V16.6009C8.23538 17.4783 9.7908 17.917 11.3822 17.917C13.9333 17.917 15.2128 17.1846 15.2208 15.7196C15.2208 15.0939 15.0049 14.5598 14.5731 14.1173C14.5339 14.0772 14.4939 14.0381 14.4531 14H3V12H21V14H17.1538ZM13.076 11H7.62908C7.4566 10.8433 7.29616 10.6692 7.14776 10.4778C6.71592 9.92084 6.5 9.24559 6.5 8.45207C6.5 7.21602 6.96583 6.165 7.89749 5.299C8.82916 4.43299 10.2706 4 12.2219 4C13.6934 4 15.1009 4.32808 16.4444 4.98426V7.13591C15.2448 6.44921 13.9293 6.10587 12.4978 6.10587C10.0187 6.10587 8.77917 6.88793 8.77917 8.45207C8.77917 8.87172 8.99709 9.23796 9.43293 9.55079C9.86878 9.86362 10.4066 10.1135 11.0463 10.3004C11.6665 10.4816 12.3431 10.7148 13.076 11H13.076Z',
  },
  [ToolbarOptions.BulletList]: {
    label: 'Bullet list',
    onClick: () => editor.chain().focus().toggleBulletList().run(),
    icon: 'M8 4H21V6H8V4ZM4.5 6.5C3.67157 6.5 3 5.82843 3 5C3 4.17157 3.67157 3.5 4.5 3.5C5.32843 3.5 6 4.17157 6 5C6 5.82843 5.32843 6.5 4.5 6.5ZM4.5 13.5C3.67157 13.5 3 12.8284 3 12C3 11.1716 3.67157 10.5 4.5 10.5C5.32843 10.5 6 11.1716 6 12C6 12.8284 5.32843 13.5 4.5 13.5ZM4.5 20.4C3.67157 20.4 3 19.7284 3 18.9C3 18.0716 3.67157 17.4 4.5 17.4C5.32843 17.4 6 18.0716 6 18.9C6 19.7284 5.32843 20.4 4.5 20.4ZM8 11H21V13H8V11ZM8 18H21V20H8V18Z',
  },
  [ToolbarOptions.OrderedList]: {
    label: 'Ordered list',
    onClick: () => editor.chain().focus().toggleOrderedList().run(),
    icon: 'M8 4H21V6H8V4ZM5 3V6H6V7H3V6H4V4H3V3H5ZM3 14V11.5H5V11H3V10H6V12.5H4V13H6V14H3ZM5 19.5H3V18.5H5V18H3V17H6V21H3V20H5V19.5ZM8 11H21V13H8V11ZM8 18H21V20H8V18Z',
  },
  [ToolbarOptions.AlignLeft]: {
    label: 'Align left',
    onClick: () => editor.chain().focus().setTextAlign('left').run(),
    icon: 'M3 4H21V6H3V4ZM3 19H17V21H3V19ZM3 14H21V16H3V14ZM3 9H17V11H3V9Z'
  },
  [ToolbarOptions.AlignCenter]: {
    label: 'Align center',
    onClick: () => editor.chain().focus().setTextAlign('center').run(),
    icon: 'M3 4H21V6H3V4ZM5 19H19V21H5V19ZM3 14H21V16H3V14ZM5 9H19V11H5V9Z'
  },
  [ToolbarOptions.AlignRight]: {
    label: 'Align right',
    onClick: () => editor.chain().focus().setTextAlign('right').run(),
    icon: 'M3 4H21V6H3V4ZM7 19H21V21H7V19ZM3 14H21V16H3V14ZM7 9H21V11H7V9Z'
  },
  [ToolbarOptions.AlignJustify]: {
    label: 'Align justify',
    onClick: () => editor.chain().focus().setTextAlign('justify').run(),
    icon: 'M3 4H21V6H3V4ZM3 19H21V21H3V19ZM3 14H21V16H3V14ZM3 9H21V11H3V9Z'
  },
});
